<template>
  <div>
    <div class="wrap">
      <img class="banner"  mode="widthFix"  src="https://ysh-cdn.kaidicloud.com/test/organization/new-fast-enter-bg1.png" />
      <img class="wrapper-border" style="bottom:15px" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/faster-enter-form-border.png" />
      <div class="form" style="bottom:17px">
        <div class="cell">
          <div class="cell-title">
            机构名称
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>

          <div style="display: flex">
            <input class="cell-input" placeholder="请输入" placeholder-class="cell-placeholder" v-model="name" />
          </div>
        </div>

        <div class="cell">
          <div class="cell-title">
            联系人姓名
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>
          <div style="display: flex">
            <input class="cell-input" placeholder="请输入" placeholder-class="cell-placeholder" v-model="contactName" />
          </div>
        </div>
        <div class="cell">
          <div class="cell-title">
            联系人手机号
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>
          <div style="display: flex">
            <input class="cell-input" placeholder="请输入您的手机号码" placeholder-class="cell-placeholder" type="number" maxlength="11" v-model="contactPhone" />
          </div>
        </div>
      </div>

      <!-- <img class="introduce" src="https://ysh-cdn.kaidicloud.com/test/organization/enter_h5_bg8.png" @click="goToIntroduct" /> -->
    </div>
    <!-- <img class="banner" style="height: 310px" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/enter_h5_bg7.png" />-->

    <img class="banner" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/fast-enter-bg2.png" /> 
    <div class="wrap">
      <img class="wrapper-border" style="bottom: 416px" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/faster-enter-form-border.png" />
      <div class="form" style="bottom: 418px">
        <div class="cell">
          <div class="cell-title">
            机构名称
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>

          <div style="display: flex">
            <input class="cell-input" placeholder="请输入" placeholder-class="cell-placeholder" v-model="name" />
          </div>
        </div>

        <div class="cell">
          <div class="cell-title">
            联系人姓名
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>
          <div style="display: flex">
            <input class="cell-input" placeholder="请输入" placeholder-class="cell-placeholder" v-model="contactName" />
          </div>
        </div>
        <div class="cell">
          <div class="cell-title">
            联系人手机号
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>
          <div style="display: flex">
            <input class="cell-input" placeholder="请输入您的手机号码" placeholder-class="cell-placeholder" type="number" maxlength="11" v-model="contactPhone" />
          </div>
        </div>
      </div>

      <img class="banner" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/new-fast-enter-bg3.png" />
    </div>
    <div class="footer">
      <!-- <img class="footer-bg" src="https://ysh-cdn.kaidicloud.com/test/organization/enter-fast-btn-bg.png" /> -->
      <img class="footer-bg"  src="https://ysh-cdn.kaidicloud.com/test/organization/faster-enter-footer-bg2.png" />
      <div class="footer-text" @click="onPrivacyAgreement">隐私协议</div>
      <img class="footer-btn" src="https://ysh-cdn.kaidicloud.com/test/organization/enter-fast-btn.png" @click="onSure" />
      <div class="footer-download" @click="onDownload">下载APP</div>
    
     
    </div>
  </div>
</template>

<script>
import { postFastEnterInfo, getWxLink,postWxId,getAppVersionConfig } from '@/api/data'

import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)

export default {
  data() {
    return {
      name: '',
      contactName: '',
      contactPhone: '',
      url: '',
      gdt_vid: '',
      downloadUrl:'', // 安卓路径
      time: 0,
      time1: 0,
      time2: 0,
    }
  },
  created() {},
  async mounted() {
    this.gdt_vid = this.$route.query.gdt_vid || ''
    this.fetchData()
    if (this.gdt_vid) {
        postWxId(this.gdt_vid)
    }

    const res = await getWxLink('pages/skip/index', this.gdt_vid)
    if (res.data.state !== 1) return
    this.url = res.data.data.url
  },
  methods: {
    goToIntroduct() {
      this.$router.push({ name: 'indroduce' })
    },
    async onSure() {
      if (!this.name) {
        Toast('请输入机构名称')
        return
      }
      if (!this.contactName) {
        Toast('请输入联系人姓名')
        return
      }
      if (!this.contactPhone) {
        Toast('请输入您的手机号码')
        return
      }

      const res = await postFastEnterInfo(this.contactName, this.contactPhone, this.name)

      // 以前逻辑跳转到小程序
      // window.location.href = this.url
      this.$router.push({ name: 'yyds-investment-success' })
    },
    onPrivacyAgreement() {
      // window.location.href = 'https://h.kaidicloud.com/privacyPolicy.html'
      this.$router.push({ name: 'privacyPolicy' })
    },

    async fetchData() {
      const res = await getAppVersionConfig('ysh_official_website_product')
      this.downloadUrl = res.data.data.fullUpdateInfo.downloadUrl
    },

    // 下载app
    onDownload(){
      //判断浏览器
      var u = navigator.userAgent
      if (/MicroMessenger/gi.test(u)) {
        // 引导用户在浏览器中打开
        alert('请在浏览器中打开')
        return
      }    
      
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //Android
        this.openApp('yshapp://', 'Android')
      } else if (u.indexOf('iPhone') > -1) {
        //IOS
        this.openApp('yshapp://', 'ios')
      }
    },

    openApp(src, type) {
      let hasApp = true,
        t = 1000,
        t1 = Date.now()

      // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
      // 否则打开a标签的href链接
      var ifr = document.createElement('iframe')
      ifr.src = src
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      let that = this
      window.setTimeout(function () {
        if (!hasApp) {
          if (type == 'Android') {
            //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
            // alert('请下载APP')
            window.location.href = that.downloadUrl
          } else {
            // alert('请下载APP')
            window.location.href = 'https://apps.apple.com/app/apple-store/id1631363552?pt=124916174&ct=home&mt=8'
          }
        }
        document.body.removeChild(ifr)
      }, 2000)

      this.openTimer = setTimeout(function () {
        //启动app时间较长处理
        let t2 = Date.now()

        that.time1 = t1
        that.time2 = t2
        if (t2 - t1 < t + 100) {
          that.time = t2 - t1
          hasApp = false
        }
      }, t)

      return hasApp
    },
  },
}
</script>

<style lang="less" scoped>
.banner {
  display: block;
  width: 100%;
}

.wrap {
  width: 100%;
  position: relative;
}
.wrapper-border {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 700px;
  height: 458px !important;
}
.wrap .form {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 686px;
  height: 448px;
  border-radius: 16px;
  background-color: #fff;
}

.wrap .introduce {
  width: 100%;
  position: absolute;
  bottom: -10px;
}

.wrap .introduce .introduce-text {
  position: absolute;
  left: 184px;
  top: 58px;
  font-size: 32px;
  font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
  color: #f94418;
  line-height: 24px;
  font-weight: bold;
  text-shadow: 0px 6px 24px rgba(249, 68, 24, 0.22);
}

.wrap .introduce .introduce-btn {
  position: absolute;
  width: 220px;
  left: 488px;
  top: 20px;
}

.cell {
  position: relative;
  padding: 24px;
}

.cell .cell-title {
  font-size: 32px;
  color: #333333;
  height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.cell .required {
  width: 16px;
  height: 16px;
  margin-left: 8px;
}

.cell .cell-input {
  width: 100%;
  font-size: 28px;
  height: 44px;
  line-height: 44px;
  color: #222;
  border: none;
  background-color: transparent;
}

.cell .cell-placeholder {
  font-size: 28px;
  color: #999;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 430px;
}

.footer-bg {
  width: 100%;
  height: 100%;
}

.footer-btn {
  position: absolute;
  left: 50%;
  top: 190px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
}

.footer-text {
  position: absolute;
  left: 50%;
  top: 120px;
  transform: translate(-50%);
  font-size: 32px;
  color: #fff;
}
.footer-download{
  position: absolute;
  left: 50%;
  top: 330px;
  transform: translate(-50%);
  font-size: 32px;
  color: #fff;
}

</style>